module.exports = __webpack_public_path__ + "static/media/task4Flower2.034dbb9e.png";